<template>
    <component
        :is="type"
        :modelValue="modelValue"
        @update:modelValue="$emit('update:modelValue', $event.target.value)"
        :errors="errors"
    />
</template>

<script>
import ItemNullOption from '@/components/Gamification/Items/ItemNullOption.vue';
import ItemWeaponOptions from '@/components/Gamification/Items/ItemWeaponOptions.vue';
import ItemModifyCurrencyOptions from '@/components/Gamification/Items/ItemModifyCurrencyOptions.vue';
import ItemCardPackOptions from '@/components/Gamification/Items/ItemCardPackOptions.vue';

export default {
    name: 'ItemSpecificOptionsForm',
    props: {
        modelValue: {
            required: true,
        },
        errors: {
            required: true,
        },
        type: {
            required: true,
            type: String,
        },
    },
    components: {
        'fetch-item': ItemNullOption,
        'modify-currency': ItemModifyCurrencyOptions,
        'card-pack': ItemCardPackOptions,
        'teacher-action': ItemNullOption,
        weapon: ItemWeaponOptions,
        pet: ItemNullOption,
    },
};
</script>
